module.exports = __webpack_public_path__ + "src/assets/img/engine_two.46e6eec2.svg";